import FinanceInvoicingDiagnostics from './finance-invoicing-diagnostics.container';

export default FinanceInvoicingDiagnostics;
